var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Map',{staticClass:"animated fadeIn",attrs:{"type":"Nước mặt"}})
}
var staticRenderFns = []

export { render, staticRenderFns }